import React from 'react'
import './RestartChat.css';
import apiService from '../../Services/apiServices';

const RestartChat = (props) => {
    const { clearMessages, setShowMsgs, showMaximumChat, startLogin, setCheckThumsDownFeedback ,createOrderRequest,setShowR1FeedbackPop ,addMessages, index ,checkOfflineButton , flow ,lastInput ,item} = props
    const hasAF1 = item?.some(item => item.uiCommand === "AF1");
    const hasA3f = item?.some(item => item.uiCommand === "A3f") 
    const checkToShow = hasAF1 && hasA3f
    const bypassFlows = [
        'ByPassIntent Call Disrupt',
        'ByPassIntent Blank Call',
        'ByPassIntent Call Drop',
        'ByPassIntent Call Transfer',
    ];
    return (
        <div
            className="restart-chat-container"
            style={{
                display: "flex",
                height: "2rem",
                marginTop: '12px',
                marginBottom: "10px",
                // width: showMaximumChat ? "87%" : "92%",
                cursor: "pointer"
            }}
        >
            <button
                onClick={() => {
                    clearMessages()
                    // apiService.loginForRefresh('6')
                    startLogin()
                    setShowMsgs(false)
                    setCheckThumsDownFeedback([])
                    setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: false }));
                }}
                style={{
                    background: !createOrderRequest && "#D02F92",
                    border: `1px solid ${createOrderRequest ? '#575757' : 'white'}`,
                    borderRadius: "5px",
                    color: createOrderRequest ? '#575757' : "white",
                    // width: "6rem",
                    fontSize: "small",
                    cursor: 'pointer',
                    marginLeft: createOrderRequest ? '10px' : '36px',
                    height :'36px'
                }}
            >
                Restart Chat
            </button>
            {/* {(checkOfflineButton !== 'end' && index !== 0 && flow !== 'ByPassIntent Call Disrupt' && !checkToShow) && <button */}
            {(checkOfflineButton !== 'end' && index !== 0 && !bypassFlows.includes(flow) && !checkToShow) && <button
                onClick={() => {
                    addMessages(null, 'Blank / Transfer / Call Drop', 'Blank / Transfer / Call Drop')
                }}
                style={{
                    background: !createOrderRequest && "#D02F92",
                    border: `1px solid ${createOrderRequest ? '#575757' : 'white'}`,
                    borderRadius: "5px",
                    color: createOrderRequest ? '#575757' : "white",
                    // width: "6rem",
                    fontSize: "small",
                    cursor: 'pointer',
                    marginLeft: '16px',
                    height :'36px'
                }}
            >
                Blank / Transfer / Call Drop
            </button>}
        </div>
    )
}

export default RestartChat
